import React from 'react';
import DPDropDown from 'framework/components/DPDropDown';
import { Col, Row, Button, Label } from 'reactstrap';



const ExcelUploadContent = ({
  ExcelUploadOption,
  selectedExcelOption,
  handleDropdownOnChange,
  disabled,

  handleGenerateExcel,
  handleFileChange,
  fileInputRef,
  setSelectedType,
  selectedType,
  setSelectedExportOption,
  selectedExportOption,
  ExcelExportOptions,
  exportTypes
}) => {


  const showGenerateButton = !!selectedExcelOption;


  async function handleDataExport() {
    if (selectedExportOption == "" || selectedType == "") return


    const fileName = "output." + selectedType.toLowerCase()
    try {
      const authToken = localStorage.getItem("authToken")
      const ApiURL = window.Links.ApiURL
      const response = await fetch(`${ApiURL}ExcelUpload/exportFiles/${selectedType}/${selectedExportOption}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
      });

      // Check if the request was successful (status code in the range of 200-299)
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        // Handle unsuccessful response (status code outside the range of 200-299)
        const errorData = await response.json(); // Assuming the server returns JSON
        console.error('Error:', errorData);
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error('Fetch error:', error);
    }

    setSelectedExportOption("")
    setSelectedType("")

  }



  return (
    <React.Fragment>
      <Row className='mb-3'>
        <h4>
          Excel Upload
        </h4>
      </Row>
      <Row>
        <Col sm={12} md={6} className="mb-4-sm">
          <DPDropDown
            rowClass="mb-4-sm"
            labelText="Select Master File"
            textType="text"
            optionGroup={ExcelUploadOption}
            selectedGroup={selectedExcelOption}
            onChange={handleDropdownOnChange}
            disabled={disabled}
          />
        </Col>
        <Col>
          {showGenerateButton ?
            <Row>
              <Col sm={6} md={4} className="mb-4-sm text-start">
                <Button
                  onClick={handleGenerateExcel}
                  color="success"
                  className="btn-sm"
                  disabled={disabled}
                >
                  Download Template
                </Button>
              </Col>
            </Row>
            : null}
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={6} className="mb-4-sm">
          <Col sm={6} md={6} className="mb-4-sm">
            <Label
              htmlFor="example-text-input"
              className="col-md-4 col-form-label-sm" >
              Excel Upload
            </Label>
          </Col>
          <Col sm={6} md={6} className="mb-6-sm">
            <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} ref={fileInputRef} />
            {/* <DBFileBrowser
              type="file"
              accept=".xlsx, .xls"
              showPrewiew={handleFileChange} /> */}
          </Col>
        </Col>
      </Row>
      <Row className='mt-5 mb-3'>
        <h4>
          Excel Export
        </h4>
      </Row>
      <Row style={{marginBottom:"150px"}}>
        <Col sm={12} md={6} className="mb-4-sm">
          <DPDropDown
            rowClass="mb-4-sm"
            labelText="Select Export File"
            textType="text"
            optionGroup={ExcelExportOptions}
            selectedGroup={selectedExportOption}
            onChange={(e) => {
              setSelectedExportOption(e["value"])
            }}
            disabled={disabled}
          />
          <DPDropDown
            rowClass="mb-4-sm"
            labelText="File Type"
            textType="text"
            optionGroup={exportTypes}
            selectedGroup={selectedType}
            onChange={(e) => {
              setSelectedType(e["value"])
            }}
            disabled={disabled}
          />
          <Button color="primary" className="btn-sm" onClick={handleDataExport} disabled={disabled}>
            Export Excel File
          </Button>
        </Col>

      </Row>
    </React.Fragment>
  );
};



export default ExcelUploadContent;
